import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCurrentRefinements, useRefinementList } from 'react-instantsearch';

export interface SocialTagFilterTagsProps {
  attribute: string;
}

export default function SocialTagFilterTags({ attribute }: SocialTagFilterTagsProps): React.JSX.Element {
  const { t } = useTranslation(['social-proof']);
  const { refine } = useRefinementList({ attribute });
  const { items } = useCurrentRefinements({ includedAttributes: [attribute] });

  return (items?.[0]?.refinements?.length ?? 0) > 0 ? (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {items[0].refinements.map(({ value }) => (
        <Chip
          key={value}
          label={t(`social-proof:${(value as string).split('|')[0].toLowerCase()}.title`)}
          onDelete={() => refine(value as string)}
        />
      ))}
    </Box>
  ) : <></>;
}
